export default {
  data() {
    return {
      currentAgent: null,
    };
  },
  created() {
    this.currentAgent = navigator.userAgent;
    const self = this;
    window.onresize = () => {
      self.getcurrentAgent();
    };
  },
  computed: {
    isMobileDevice() {
      const mobileAgent = /Mobi|Android/i.test(navigator.userAgent);
      return this.$vuetify.breakpoint.mobile || mobileAgent;
    },
  },
  methods: {
    getcurrentAgent() {
      this.currentAgent = navigator.userAgent;
    },
  },
};
